import { CSSProperties } from "react";
import { ProfileMemberColumns } from "../consts/ProfileMemberColumns"
import { ProfileMemberGrid } from "../ProfileMemberGrid";
import { useCommunityMemeberMastermind } from "../../../../../hooks/manageMembers/useCommunityMemeberMastermind";
import Pagination from "../../../../components/Pagination";


type Props = {
    titleStyles: CSSProperties;
    userId: number;
    onSelect: (u: any) => void;
    reloadKey?: number;
}

export const ProfileMemberMastermind = ({ titleStyles, userId, onSelect, reloadKey }: Props) => {
    const { loading, mastermind, mastermindPage, mastermindTotalPages, setMastermindPage } = useCommunityMemeberMastermind(userId, reloadKey);
    return (
        <div className="d-flex flex-column" style={{gap: '20px'}}>
            <span style={titleStyles}>
                Mastermind Circles
            </span>
            <ProfileMemberGrid 
                data={mastermind}
                loading={loading}
                columns={ProfileMemberColumns}
                onSelect={onSelect}
            />
            {!loading && mastermind.length === 0 ? (
                <span className="text-center">There is nothing to show for now.</span>
            ): (
                <Pagination currentPage={mastermindPage} totalPages={mastermindTotalPages} onPageChange={setMastermindPage} />
            )}
        </div>
    )
}